module.exports = __webpack_public_path__ + "static/img/1_2_1.7bafc8f7.jpg";